import type {ConnectElementConfig} from '../ConnectElementList';

export const treasuryEntryBannerIsVisibleParameter = 'visible' as const;

export const TreasuryEntryBannerConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryEntryBanner" */
      '../../../components/MoneyManagement/TreasuryEntryBanner/TreasuryEntryBanner'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  htmlAttributes: {
    [treasuryEntryBannerIsVisibleParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['close'],
  customHtmlElementMethods: {
    setIsVisible: {
      type: 'AttributeSettingMethod',
      attribute: treasuryEntryBannerIsVisibleParameter,
      isInternal: true,
      description: 'Sets whether the Treasury entry banner is visible.',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description:
        'Sets the event listener called when the Treasury entry banner is dismissed.',
    },
  },
  description: 'Internal dismissible banner for EFS test accounts.',
  friendlyName: 'Treasury Entry Banner',
};
